module.exports = __webpack_public_path__ + "img/check-mapping.faa1dec2.svg";